import { OrderDraftDetail } from '~/api/orders/_types';

export const useOrderDraftDetailStore = defineStore('order-draft', () => {
    const activeOrderDraft = ref<OrderDraftDetail | null>(null);

    const reset = () => {
        activeOrderDraft.value = null;
    };

    return {
        activeOrderDraft,
        reset,
    };
});
